// src/components/FundingBonusBanner.jsx
import { useEffect, useState } from "react";
import { Gift, Sparkles } from "lucide-react";
import api from "../api/api";

const naira = (n) => "₦" + Math.round(Number(n) || 0).toLocaleString("en-NG");

export default function FundingBonusBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/wallet/bonus-info")
      .then((res) => {
        if (!cancelled && res.data && res.data.success) setInfo(res.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!info || !info.enabled || !Array.isArray(info.tiers) || info.tiers.length === 0) return null;

  const top = info.tiers[info.tiers.length - 1];
  let exampleBonus = Math.floor((top.minAmount * top.percent) / 100);
  if (info.maxBonus > 0 && exampleBonus > info.maxBonus) exampleBonus = info.maxBonus;

  return (
    <div className="mb-5 rounded-2xl border border-amber-200 dark:border-amber-800/50 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/15 dark:to-orange-900/10 p-4 shadow-sm">
      <div className="flex items-center gap-2.5 mb-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-400/90 text-white">
          <Gift size={18} />
        </span>
        <div>
          <p className="text-sm font-bold text-gray-900 dark:text-white leading-tight">Fund more, get more</p>
          <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-tight">
            Earn a bonus on every large deposit
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {info.tiers.map((t) => (
          <div
            key={t.minAmount}
            className="flex items-center justify-between rounded-xl bg-white/80 dark:bg-white/[0.05] border border-amber-100 dark:border-amber-800/30 px-3 py-2.5"
          >
            <p className="text-xs text-gray-700 dark:text-gray-200">
              Deposit <span className="font-semibold">{naira(t.minAmount)}</span> or more
            </p>
            <span className="inline-flex items-center gap-1 rounded-full bg-amber-500 px-2.5 py-1 text-[11px] font-bold text-white">
              <Sparkles size={11} />+{t.percent}% bonus
            </span>
          </div>
        ))}
      </div>

      <p className="mt-3 text-[11px] leading-relaxed text-gray-600 dark:text-gray-400">
        Example: deposit {naira(top.minAmount)} and get {naira(exampleBonus)} extra, so{" "}
        <span className="font-semibold">{naira(top.minAmount + exampleBonus)}</span> lands in your wallet.
        The bonus is added automatically after your deposit is confirmed, and we will notify you.
        {info.maxBonus > 0 ? " Bonus is capped at " + naira(info.maxBonus) + " per deposit." : ""}
      </p>
    </div>
  );
}